import {
  Component,
  Input,
  OnChanges,
  SimpleChange,
  SimpleChanges,
} from '@angular/core';
import {
  ModifiedSessionDocumentInfo,
  SessionPaymentTransaction,
} from '../../models';

interface PaymentSummaryTableChanges extends SimpleChanges {
  modifiedDocuments: SimpleChange;
}

@Component({
  selector: 'payment-tabbed-transaction-document-table',
  templateUrl: './tabbed-transaction-document-table.component.html',
  styleUrls: ['./tabbed-transaction-document-table.component.scss'],
})
export class TabbedTransactionDocumentTableComponent implements OnChanges {
  @Input() hasMultipleTransactions: boolean;
  @Input() modifiedDocuments: ModifiedSessionDocumentInfo[];
  @Input() isSurchargeFeeVisible: boolean;
  @Input() transactions: SessionPaymentTransaction[];
  @Input() excludedTransactionTableCols: string[];
  @Input() excludedDocumentTableCols: string[];
  @Input() showModifiedDocuments: boolean;

  ngOnChanges(changes: PaymentSummaryTableChanges): void {
    if (
      changes.modifiedDocuments?.isFirstChange() &&
      !this.showModifiedDocuments
    ) {
      this.markModifiedToFalse(changes.modifiedDocuments.currentValue);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  private markModifiedToFalse(
    modifiedDocuments: ModifiedSessionDocumentInfo[],
  ) {
    modifiedDocuments.forEach((x) => {
      // eslint-disable-next-line no-param-reassign
      x.modified = false;
    });
  }
}
